// Auto-generated by scripts/write-build-version.js
export const BUILD_VERSION = "0.1.0-7df4326-1793812627076";
export const BUILD_LABEL = "0.1.0 (7df4326)";
export const BUILD_TIME = "2026-11-04T17:17:07.075Z";
